import React from "react";
import Complaint from "./views/Complaint";

const App = () => {
    return <Complaint />;
};

export default App;
